import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { APIUrl } from "src/app/features-common/constants/APIUrls";
import { BaseService } from "src/app/framework/services/base.service";
import { environment } from "src/environments/environment";

@Injectable()
export class ProductService extends BaseService {
  constructor(private http : HttpClient) {
    super();
  }
  getAllCountries(): Observable<any> {
    let url = APIUrl.getAllCountries;
    return this.httpService.get(url);
  }
  getPinlessCarriers(): Observable<any> {
    let url = APIUrl.pinlessCarriers;
    return this.httpService.get(url);
  }
  getPinlessCountries(): Observable<any> {
    let url = APIUrl.pinlessCountries;
    return this.httpService.get(url);
  }
  getConfigValues() {
    let params = new HttpParams().set("config_name", "BusinessType");
    return this.httpService.getRetailerData(APIUrl.congifValues, params);
  }

  // Get all products details
  getallproducts() {
    return this.httpService.get(APIUrl.products);
  }

  // Get all products details
  getproducts() {
    return this.httpService.get(APIUrl.products);
  }
  // Get all Product types
  getallproducttypes() {
    let params = new HttpParams().set("config_name", "ProductType");
    return this.httpService.getRetailerData(APIUrl.congifValues, params);
  }
  // Get all plan types
  getallplantypes() {
    let params = new HttpParams().set("config_name", "PlanType");
    return this.httpService.getRetailerData(APIUrl.congifValues, params);
  }

  // Get all Response Types
  getallresponseTypes() {
    let params = new HttpParams().set("config_name", "ResponseType");
    return this.httpService.getRetailerData(APIUrl.congifValues, params);
  }

  // Get all ProviderService
  getallProviderService() {
    let params = new HttpParams().set("config_name", "ProviderService");
    return this.httpService.getRetailerData(APIUrl.congifValues, params);
  }
  // Get all provider details
  getallproviders() {
    return this.httpService.get(APIUrl.allProviders);
  }
  // Get all provider details
  getactiveproviders() {
    return this.httpService.get(APIUrl.activeProviders);
  }

  getCarriers() {
    return this.httpService.get(APIUrl.carriers);
  }

  getCarrierCountries() {
    return this.httpService.get(APIUrl.country);
  }
  //TransactionTypes
  getTransactionTypes() {
    let params = new HttpParams().set("config_name", "TransactionType");
    return this.httpService.getRetailerData(APIUrl.congifValues, params);
  }
  //codeGroup
  getcodeGroups() {
    let params = new HttpParams().set("config_name", "InvoiceGrouping");
    return this.httpService.getRetailerData(APIUrl.congifValues, params);
  }
  productInactive(httpParams) {
    let params = httpParams;
    return this.httpService.put(APIUrl.productStatus, params);
  }

  getserviceCountry() {
    return this.httpService.get(APIUrl.country);
  }
  addProduct(params) {
    return this.httpService.post(APIUrl.products, params);
  }
  updateProduct(params) {
    return this.httpService.put(APIUrl.products, params);
  }

  addProductHistory(params) {
    //return this.httpService.getParams(APIUrl.provider + '/' + APIUrl.history, params)
    return this.httpService.getParams(APIUrl.productshistory, params);
  }
  getProductDetails(productId) {
    let url = `${APIUrl.products}/${productId}`;
    return this.httpService.get(url);
  }
  getAllActivePricelists() {
    return this.httpService.get(APIUrl.pricelists);
  }
  getAllPricelists() {
    return this.httpService.get(APIUrl.pricelists);
  }

  getAllPricelistnametype() {
    return this.httpService.get(APIUrl.pricelistnametype);
  }
  postFile(fileToUpload: File, providerid) {
    //const endpoint = this.httpService.get(APIUrl.import)
    const formData: FormData = new FormData();
    formData.append("productsFile", fileToUpload, fileToUpload.name);
    formData.append("providerId", providerid);
    return this.httpService.post(APIUrl.importproducts, formData);
  }

  /**
   * Export all produtcs to EXCEL CSV
   */
   exportAllProducts():Observable<any>{
     let url = `${environment.hostUrl}:${environment.port}/${APIUrl.exportAllProducts}`;
    return this.http.get(url, { responseType: "blob" as "json" });
   }

   /**
    * 
    * GET all pinless rates grid data
    */
  getPinlessRatesGrid(): Observable<any> {
    return this.httpService.get(APIUrl.pinlessRates);
  }
  
  /**
   * 
   * Upload pinless rates file
   */
  uploadPricelist(fileToUpload: File) {
    //const endpoint = this.httpService.get(APIUrl.import)
    const formData: FormData = new FormData();
    formData.append("pinlessRatesFile", fileToUpload, fileToUpload.name);
    return this.httpService.post(APIUrl.uploadPinlessRates, formData);
  }
}
